<template>
  <div class="conny-strip" role="status">
    <span class="conny-strip__icon" aria-hidden="true">{{ icon }}</span>
    <div>
      <strong>{{ title }}</strong>
      <small>{{ detail }}</small>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConnyStatusStrip',
  props: {
    icon: { type: String, default: '✨' },
    title: { type: String, required: true },
    detail: { type: String, default: '' }
  }
}
</script>

<style scoped>
.conny-strip {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 11px 13px;
  border: 1px solid rgba(255, 218, 112, .28);
  border-radius: 14px;
  background: rgba(255, 255, 255, .07);
  color: #fff;
}
.conny-strip__icon {
  display: grid;
  width: 38px;
  height: 38px;
  flex: 0 0 38px;
  place-items: center;
  border-radius: 12px;
  background: rgba(251, 200, 68, .16);
  font-size: 20px;
}
strong, small { display: block; }
strong { font-size: 14px; font-weight: 800; }
small { margin-top: 2px; color: rgba(255, 255, 255, .68); font-size: 12px; }
</style>
